import React, { useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useGetWorkflowServicesQuery, WorkflowService } from "../../../../__generated__/api";
import { NoDataOrError } from "../../../../pages/error/Error";
import Loading from "../../../loading/Loading";
import Styles from "./IntegrationsTab.module.scss";
import FormGroup from "../../../theme/form-group/FormGroup";
import Button from "../../../theme/button/Button";
import { useWorkflow } from "../../providers/WorkflowProvider";

export default function IntegrationsTab() {
    const { data: services, loading: isLoading, error } = useGetWorkflowServicesQuery();
    const { setSelectedService } = useWorkflow();

    const [search, setSearch] = useState("");

    if (isLoading) {
        return <Loading />;
    }

    if (error || !services?.workflowServices) {
        return <NoDataOrError error={error} />;
    }

    let serviceList = services.workflowServices;

    if (search) {
        const searchQuery = search.toLowerCase();
        serviceList = serviceList.filter(service => service.name.toLowerCase().includes(searchQuery)
            || service.shortDescription?.toLowerCase().includes(searchQuery));
    }

    return (
        <div className="d-flex flex-column gap-2">
            <FormGroup
                type="search"
                placeholder="Search..."
                prefixIcon={<RiSearchLine />}
                groupClassName={Styles["action-search-input"]}
                value={search}
                size="small"
                onChange={evt => setSearch(evt.target.value)}
            />
            {
                serviceList.map(service => (
                    <Button
                        variant="none"
                        className={Styles["service-card"]}
                        key={service.id}
                        onClick={() => setSelectedService(service as WorkflowService)}
                    >
                        <img
                            src={service.squareIconUrl ?? service.iconUrl as string}
                            className={Styles["service-image"]}
                            alt={service.name}
                        />
                        <div className={Styles["service-content"]}>
                            <div className={Styles["service-name"]}>
                                {service.name}
                            </div>
                            <div className={Styles["service-description"]}>
                                {service.shortDescription}
                            </div>
                        </div>
                    </Button>
                ))
            }
        </div>
    );
}
